"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorCircle = function ErrorCircle() {
  return _react2.default.createElement(
    "g",
    { id: "error-circle" },
    _react2.default.createElement("path", { d: "M250,0C112,0,0,111.9,0,250c0,138.1,112,250,250,250c138.1,0,250-111.9,250-250C500,111.9,388.1,0,250,0z M282.7,395h-65.3 v-67.2h65.3V395z M277.3,278.3h-55L212.3,105h75.5L277.3,278.3z" })
  );
};

exports.default = ErrorCircle;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/ErrorCircle.js
// module id = 2945
// module chunks = 4